import React from 'react'
import PropTypes from 'prop-types'
import { Card, Empty, Table, Tag } from 'antd'
import {
  PRIORITY_COLORS,
  attentionLabel,
  attentionPriority,
  formatDateTime
} from './utils'

/* eslint-disable react/display-name */
const columns = [
  {
    title: 'Kind',
    key: 'kind',
    render: (_, a) => attentionLabel(a.kind)
  },
  {
    title: 'Priority',
    key: 'priority',
    render: (_, a) => {
      const priority = attentionPriority(a.kind, a.priority)
      return <Tag color={PRIORITY_COLORS[priority]}>{priority}</Tag>
    }
  },
  {
    title: 'Raised',
    key: 'raisedAt',
    render: (_, a) => formatDateTime(a.raisedAt)
  },
  {
    title: 'Cleared',
    key: 'clearedAt',
    render: (_, a) =>
      a.clearedAt ? formatDateTime(a.clearedAt) : <Tag color="gold">open</Tag>
  },
  {
    title: 'Cleared by',
    key: 'clearedBy',
    // `system` means the sweep cleared it on its own — worth distinguishing from a person, because
    // it says nobody has actually looked at this shipment.
    render: (_, a) => {
      if (!a.clearedAt) return '—'
      return a.clearedBy === 'system' ? 'Automatic' : a.clearedBy || '—'
    }
  },
  {
    title: 'Note',
    key: 'note',
    render: (_, a) => a.note || '—'
  }
]
/* eslint-enable react/display-name */

// Newest first, as the server sends them; never re-sorted here.
const AlertHistory = ({ alerts }) => (
  <Card title="Alert history">
    <Table
      size="small"
      pagination={false}
      rowKey="id"
      dataSource={alerts || []}
      columns={columns}
      scroll={{ x: 700 }}
      locale={{ emptyText: <Empty description="No alerts." /> }}
    />
  </Card>
)

AlertHistory.propTypes = {
  alerts: PropTypes.array
}

export default AlertHistory
